// The building JSON written by exporter/export_hvac.py (Revit internal feet, Revit X east / Y north / Z up).

export type P3 = [number, number, number];
export type BBox = { min: P3; max: P3 } | null;

export interface Level { id: number; name: string; elevation: number }
export interface RWall {
  id: number; type: string | null; function: string; thicknessFt: number; level: string | null;
  baseOffsetFt: number | null; heightFt: number | null; centreline: P3[]; bbox: BBox; openings: number[];
}
export interface Connector { domain: string; origin: P3; system?: string; radiusFt?: number; direction?: P3; flow?: string }
export interface Instance {
  id: number; category: string; family: string | null; type: string | null; level: string | null; location: P3 | null;
  facing: P3 | null; hand: P3 | null; host: number | null; hostCategory: string | null; bbox: BBox;
  connectors: Connector[]; mark: string | null; comments: string | null; room: string | null; elevationFromLevel?: number | null;
}
export interface Opening extends Instance { widthFt: number | null; heightFt: number | null; sillFt: number | null; headFt: number | null }
export interface RRoom {
  id: number; name: string; number: string; level: string; areaSqFt: number; perimeterFt: number;
  unboundedHeightFt: number; volumeCuFt?: number; tag: P3 | null; loops: P3[][];
}
export interface RCeiling { id: number; type: string; level: string | null; heightAboveLevelFt: number | null; thicknessFt: number | null; bbox: BBox; loops: P3[][] }
export interface RSlab { id: number; type: string; level: string | null; bbox: BBox; thicknessFt?: number | null; loops: P3[][] }
export interface RPipe { id: number; systemType: string | null; pts: P3[]; diameterFt: number | null }

export interface RevitModel {
  title: string; units: "ft"; levels: Level[]; walls: RWall[]; doors: Opening[]; windows: Opening[]; rooms: RRoom[];
  ceilings: RCeiling[]; floors: RSlab[]; roofs: RSlab[]; columns: { id: number; type: string; bbox: BBox }[];
  stairs: { id: number; type: string; bbox: BBox }[]; shafts: { id: number; bbox: BBox }[];
  grids: { name: string; curve: P3[] }[]; equipment: Instance[]; ducts: unknown[]; airTerminals: Instance[];
  pipes: RPipe[]; counts: Record<string, number>; projectPosition?: { east: number; north: number; elevation: number; angleRad: number };
}

export const ftIn = (ft: number) => {
  const s = ft < 0 ? "-" : ""; let a = Math.abs(ft); let f = Math.floor(a); let i = Math.round((a - f) * 12);
  if (i === 12) { f += 1; i = 0; }
  return `${s}${f}'-${i}"`;
};
